/* unplugin-vue-components disabled */import { render } from "./zhuhmobile.vue?vue&type=template&id=4b2ff024&scoped=true"
import script from "./zhuhmobile.vue?vue&type=script&lang=js"
export * from "./zhuhmobile.vue?vue&type=script&lang=js"

import "./zhuhmobile.vue?vue&type=style&index=0&id=4b2ff024&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2ff024"]])

export default __exports__